import DOMPurify from 'dompurify';

import {
  BANK_ID_ATTRIBUTE,
  MAUSOLEUM_PLAN_ALLOWED_ATTR,
  MAUSOLEUM_PLAN_ALLOWED_TAGS,
} from 'src/constants';
import type { IBank } from 'src/interfaces';

const escapeSvgAttribute = (value: string) =>
  value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');

const sanitizeMausoleumPlan = (mausoleumPlan: string) =>
  DOMPurify.sanitize(mausoleumPlan, {
    ALLOWED_ATTR: MAUSOLEUM_PLAN_ALLOWED_ATTR,
    ALLOWED_TAGS: MAUSOLEUM_PLAN_ALLOWED_TAGS,
    ALLOW_ARIA_ATTR: true,
    ALLOW_DATA_ATTR: true,
  });

export const getMausoleumPlanWithBanks = (
  mausoleumPlan: string = '',
  banksWithPlans: { bank: IBank; plan: string }[]
) => {
  const svgCloseTagIndex = mausoleumPlan.lastIndexOf('</svg>');

  if (svgCloseTagIndex < 0) {
    return sanitizeMausoleumPlan(mausoleumPlan);
  }

  const banksPlan = banksWithPlans
    .map(
      ({ bank, plan }) =>
        `<g class="mausoleum-plan__bank" ${BANK_ID_ATTRIBUTE}="${escapeSvgAttribute(
          bank.id
        )}" aria-label="${escapeSvgAttribute(bank.name)}" role="button">${plan}</g>`
    )
    .join('');

  return sanitizeMausoleumPlan(`
    ${mausoleumPlan.slice(0, svgCloseTagIndex)}
    ${banksPlan}
    ${mausoleumPlan.slice(svgCloseTagIndex)}
    `);
};
